/* eslint-disable react/prop-types */
import React from "react";
import Button from "../../../../component/button/Button";
import SelectInput from "../../../../component/input/SelectInput";
import TextInput from "../../../../component/input/TextInput";

// eslint-disable-next-line react/prop-types
function WorkLog({
  workLogIndex,
  workLogValues,
  onRemoveWorkLog,
  onWorkLogChange
}) {
  return (
    <div className="row mt-1 mb-1 ">
      <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12 ">
        <SelectInput
          type="text"
          required={false}
          isLabeled={false}
          textWhite={false}
          label="Description"
          htmlFor="queryTitle"
          name="addDescription"
          placeholder="Description"
          value={workLogValues.addDescription}
          onChange={onWorkLogChange(workLogIndex)}
        >
          <option value=""> Select Type</option>
          <option value="CARPENTERS">CARPENTERS</option>
          <option value="CIVIL MASONS UNSKILLED">
            CIVIL MASONS UNSKILLED
          </option>
          <option value="PAINTERS AND POLISHERS">
            PAINTERS AND POLISHERS
          </option>
          <option value="POP MASONS">POP MASONS</option>
          <option value="SUPERVISION">SUPERVISION</option>
          <option value="EXTRA LABOUR">EXTRA LABOUR</option>
        </SelectInput>
      </div>
      <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12">
        <TextInput
          type="text"
          required={false}
          label="Manpower"
          textWhite={false}
          htmlFor="manpower"
          name="addManpower"
          placeholder="Manpower"
          value={workLogValues.addManpower}
          onChange={onWorkLogChange(workLogIndex)}
        />
      </div>
      <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12">
        <TextInput
          type="text"
          required={false}
          textWhite={false}
          htmlFor="queryTitle"
          label="Onsite Assignment"
          name="addOnSiteAssignment"
          placeholder="Onsite Assignment"
          onChange={onWorkLogChange(workLogIndex)}
          value={workLogValues.addOnSiteAssignment}
        />
      </div>
      <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12 pt-3">
        <Button
          type="button"
          title="Remove"
          name="removeButton"
          isBackgroundColor={false}
          onClick={onRemoveWorkLog(workLogIndex)}
          icon="mdi mdi-minus-circle-outline mr-2"
          className="btn text-white btn-block btn-danger"
        />
      </div>
    </div>
  );
}

export default WorkLog;
